(() => {
  const GUTTER = 40;
  const HEADER_GAP = 16;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const sections = Array.from(document.querySelectorAll('[data-scroll-pin]'));
  if (!sections.length) return;

  let stickTop = 0;

  const lock = () => {
    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top;
      section.pinMovers.forEach((mover) => {
        const held = stickTop - (sectionTop + mover.pinStart);
        mover.style.translate = `0 ${Math.min(Math.max(held, 0), mover.pinLimit)}px`;
      });
    });
  };

  const stickyHeight = () => {
    let total = 0;
    document.querySelectorAll('.shopify-section').forEach((section) => {
      if (getComputedStyle(section).position !== 'sticky') return;
      const top = parseFloat(getComputedStyle(section).top) || 0;
      total = Math.max(total, top + section.offsetHeight);
    });
    return total ? total + HEADER_GAP : 0;
  };

  const measure = () => {
    stickTop = stickyHeight();
    sections.forEach((section) => {
      section.pinMovers = Array.from(section.querySelectorAll('[data-scroll-pin-move]'));
      const height = section.offsetHeight;
      const sectionTop = section.getBoundingClientRect().top;
      section.pinMovers.forEach((mover) => {
        mover.style.translate = '';
        const anchor = mover.querySelector('[data-scroll-pin-anchor]') || mover;
        mover.pinStart = anchor.getBoundingClientRect().top - sectionTop;
        const bottoms = Array.from(mover.children, (child) => child.getBoundingClientRect().bottom);
        const lowest = bottoms.length ? Math.max(...bottoms) : mover.getBoundingClientRect().bottom;
        mover.pinLimit = Math.max(height - (lowest - sectionTop) - GUTTER, 0);
      });
    });
    lock();
  };

  let queued = false;
  let stale = false;
  const request = (needsMeasure) => () => {
    stale = stale || needsMeasure;
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      if (stale) {
        stale = false;
        measure();
      } else {
        lock();
      }
    });
  };

  measure();
  window.addEventListener('scroll', request(false), { passive: true });
  window.addEventListener('resize', request(true), { passive: true });
})();
